export default {
  CASES_TABLE: {
    CASE_QUICK_FILTERS: {
      all: 'Minden ügy',
      todo: 'Teendők',
      todo_admin: 'Admin',
      todo_attorney: 'Ügyvédi',
    },
    ERROR_MESSAGES: {
      ERROR_WHILE_LOADING_CASES: 'Valami hiba történt az ügyek betöltésekor!',
      ERROR_WHILE_LOADING_PARTNERS: 'Valami hiba történt a partnerek betöltésekor!',
      ERROR_WHILE_LOADING_STATES: 'Valami hiba történt a státuszok betöltésekor!',
      ERROR_WHILE_EXPORTING_CASES: 'Valami hiba történt az ügyek exportálásakor!',
    },
    EXPORT: {
      BUTTON: 'Ügyek exportálása (Excel)',
      FILENAME: 'ugyek-export',
    },
    FILTERS: {
      APPLY: 'Szűrés',
      STAGE_LABEL: 'Fő állapot',
      CLIENT: {
        LABEL: 'Hitelező',
        PLACEHOLDER: 'Kezdjen el gépelni...',
      },
      CASE_ID: {
        LABEL: 'Ügyazonosító',
        PLACEHOLDER: 'Kezdjen el gépelni...'
      },
      DEBTOR_NAME: {
        LABEL: 'Adós',
        PLACEHOLDER: 'Kezdjen el gépelni...'
      },
      PARTNER: {
        LABEL: 'Partner',
        PLACEHOLDER: 'Kezdjen el gépelni...',
      },
      PRODUCT: {
        LABEL: 'Szolgáltatás',
        PLACEHOLDER: 'Válasszon szolgáltatást...',
        NOTICE: 'Fizetési felszólítás',
        DEMAND_LETTER: 'Ügyvédi felszólító levél',
        HARD_1: 'Fizetési meghagyás',
        HARD_2: 'Fizetési meghagyás - végrehajtás',
        COFACE: 'Coface',
      },
      STAGE: {
        DRAFT: 'Piszkozat',
        ONGOING: 'Folyamatban',
        CLOSED: 'Lezárva',
      },
      STATE: {
        LABEL: 'Állapot',
        PLACEHOLDER: 'Kezdjen el gépelni...',
      },
      STARTED_AT: {
        LABEL: 'Indítás dátuma',
        MIN_LABEL: 'Indítás dátuma (tól)',
        MAX_LABEL: 'Indítás dátuma (ig)',
      },
      TRANSITION_AT: {
        LABEL: 'Esemény dátuma',
        MIN_LABEL: 'Esemény dátuma (tól)',
        MAX_LABEL: 'Esemény dátuma (ig)',
      },
      "CLEAR_ALL": "Szűrők törlése"
    },
    TABLE_INFO: {
      CLOSED: 'Lezárt ügyek',
      CLOSED_INFO:
        'Ezek az ügyek, amik vagy sikeresen kifizetésre kerültek, vagy egyéb okból lettek leállítva.',
      DRAFT: 'Piszkozatok',
      DRAFT_INFO:
        'Ezek az ügyek, amiket félbehagytál. Ha egy Számlázz.hu-s számláról az Ügyvédi és jogi megoldások linkre kattintva jöttél ide, akkor minden ilyen átkattintással keletkezett egy piszkozat.',
      ONGOING: 'Nyitott ügyek',
      ONGOING_INFO:
        'Ezek az ügyek, amik sikeresen elindultak, és jelenleg is futnak. Ha bármelyikkel teendőd lenne, akkor arról emailben is értesítünk majd.',
    },
    HEADERS: {
      CASE_ID: 'Ügyazonosító',
      REMAINING_CLAIMS: 'Fennálló követelés',
      ORIGINAL_CLAIMS: 'Követelés',
      PAYMENT_STATUS: 'Kifizetettség',
      PARTIES: 'adós',
      CLIENT: 'Hitelező',
      STATE: 'Állapot',
      STARTED_AT: 'Indítva',
      EXPECTED_TRANSITION: 'Várható státusz',
      LAST_EVENT: 'Utolsó esemény',
      DEADLINE: 'Határidő',
    },
    CASE_ACTIONS: {
      DOWNLOAD_DOCUMENTS: 'Dokumentumok letöltése',
      DELETE: 'Ügy törlése',
      EDIT: 'Ügy szerkesztése',
      PAY_WITH_CARD: 'Kártyával fizetek',
      RESEND_PROFORMA: 'Díjbekérő újraküldése',
      RESEND_PROFORMA_CONFIRM: 'A díjak módosulni fognak. Mentés után szeretnéd újraküldeni a díjbekérőt a hitelezőnek?',
      RESEND_PROFORMA_SUCCESS: 'Díjbekérő sikeresen elküldve',
      RESEND_PROFORMA_ERROR: 'A díjbekérő újraküldése nem sikerült.',
      CREATE_FEE_CHANGE_INVOICE_ASANA_TASK: 'Számla feladat létrehozása',
      CREATE_FEE_CHANGE_INVOICE_ASANA_TASK_CONFIRM: 'A közjegyzői eljárási díjak csökkenni fognak. A mentés után elküldünk egy Asana feladatot a visszatérítésről.',
      CREATE_FEE_CHANGE_INVOICE_ASANA_TASK_INCREASE_CONFIRM: 'A közjegyzői eljárási díjak nőni fognak. A mentés után elküldünk egy díjbekérőt a hitelezőnek.',
      CREATE_FEE_CHANGE_INVOICE_ASANA_TASK_SUCCESS: 'Asana feladat sikeresen létrehozva.',
      CREATE_FEE_CHANGE_INVOICE_ASANA_TASK_ERROR: 'Az Asana feladatot nem sikerült létrehozni.',
      BAILIFF_CONTACT: 'Végrehajtó elérhetősége',
      SEARCH_PLACEHOLDER: 'Keresés...',
      NO_ACTIONS: 'Nincs elérhető esemény',
    },
    START_PAYMENT_CHOICE: {
      TITLE: 'Ügyindítási díj befizetése',
      DESCRIPTION: 'Kérjük, válassza ki, hogy milyen módon szeretné befizetni az ügyindítási díjat. Az ügyindítási díjról ',
      MORE_INFO: 'itt olvashat bővebben',
      CARD_TITLE: 'Bankkártyával fizetek',
      CARD_DESCRIPTION: 'Biztonságos és gyors',
      TRANSFER_TITLE: 'Átutalással fizetek (Díjbekérő)',
      TRANSFER_DESCRIPTION: '48 óra átfutási idő',
      CREDIT_TITLE: 'Kredittel fizetek',
      CREDIT_DESCRIPTION: 'Előre megvásárolt egyenlegből',
      SUBMIT_CARD: 'Bankkártyával fizetek',
      SUBMIT_TRANSFER: 'Díjbekérőt kérek',
      SUBMIT_CREDIT: 'Kredittel fizetek',
      TOOLTIP: 'Ügyindítási díj befizetése',
    },
    TRANSFER_INSTRUCTIONS: {
      TITLE: 'A díjbekérőt emailben kiküldtük.',
      DESCRIPTION: 'A befizetést 24 órán belül feldolgozzuk.',
      AMOUNT_LABEL: 'Utalandó összeg',
      BENEFICIARY_LABEL: 'Kedvezményezett',
      ACCOUNT_NUMBER_LABEL: 'Számlaszám',
      REFERENCE_LABEL: 'Közlemény',
      BUTTON_LABEL: 'Tovább az ügyeimhez',
    },
    ACTION_GROUPS: {
      CASE_ACTIONS: 'Műveletek',
      NO_ITEMS: 'Nincs művelet ebben a csoportban',
    },
    CASE_DETAILS: {
      DETAILS_LABEL: 'Részletek',
      EVENTS_LABEL: 'Események',
    },
    NO_CASES: {
      TITLE: 'Nem található ügy a megadott feltételekkel',
    },
    MORE_CURRENCIES: '+{{count}} további',
    ACCESSORY_CLAIM: 'járulékos követelés',
    PAYMENT_STATUS: {
      PARTIAL: 'Részleges kifizetés',
      FULL: 'Teljes kifizetés',
    },
    COUNTDOWN: '{{hours}} óra {{minutes}} perc',
    COUNTDOWN_WITH_DAYS: '{{days}} nap {{hours}} óra {{minutes}} perc',
    COUNTDOWN_UNTIL: 'Befejezés legkésőbb',
    COUNTDOWN_OVERDUE: 'Befejezés hamarosan',
    TOOLTIP: {
      ADDRESS_LABEL: 'Cím',
      TAX_NUMBER_LABEL: 'Adószám',
      EXPECTED_EVENT: 'Következő státusz: {{event}}',
      DEADLINE: 'Határidő: {{date}}',
      DEADLINE_OVERDUE: 'Határidő: {{date}} lejárt',
      EXPECTED_TRANSITION_TIMING_UPCOMING: 'Ekkor: {{date}}',
      EXPECTED_TRANSITION_TIMING_OVERDUE: 'Hamarosan',
    },
    COPY_SUCCESS: "Az ügyazonosító vágólapra másolva",
    CIVIL_LAWSUIT_DIALOG: {
      TITLE: 'Határidős lehetőség: bírósági eljárás indítása',
      INTRO_PARTIAL:
        'Az adós ({{debtorName}}) részben vitatta a fizetési meghagyás tartalmát.',
      INTRO_FULL:
        'Az adós ({{debtorName}}) teljes egészében vitatta a fizetési meghagyás tartalmát, így a fizetési meghagyásos eljárást a közjegyző lezártnak tekinti.',
      INSTRUCTIONS_PARTIAL:
        'A vitatott követelésrészek érvényesítésére {{deadline}} határidőig pert kezdeményezhet. Ehhez jogi képviselő megbízása szükséges; ajánljuk, hogy vegye fel a kapcsolatot az alábbi ügyvédi partnerrel.',
      INSTRUCTIONS_FULL:
        'Az ügy folytatására {{deadline}} határidőig pert kezdeményezhet a követelés érvényesítésére. Ehhez jogi képviselő megbízása szükséges; ajánljuk, hogy vegye fel a kapcsolatot az alábbi ügyvédi partnerrel.',
      LAW_FIRM_HEADING: 'Ügyvédi partner',
      CLOSE: 'Bezárás',
      LINK_TOOLTIP: 'Polgári per – kapcsolat és teendők',
    },
    DOWNLOAD_DOCUMENTS_DIALOG: {
      TITLE: 'Ügydokumentumok letöltése',
      DESCRIPTION: 'Válaszd ki, mely dokumentumok kerüljenek a zip fájlba.',
      EVENT_ATTACHMENTS: 'Események mellékletei ({{count}})',
      LEGAL_RELATIONSHIP_CONTRACT: 'Jogviszony szerződés ({{count}})',
      CLAIM_FILES: 'Követelés fájlok ({{count}})',
      DOWNLOAD: 'Zip letöltése',
      CANCEL: 'Mégse',
      NO_DOCUMENTS: 'Ehhez az ügyhöz nincs letölthető dokumentum.',
      LOAD_ERROR: 'Az ügydokumentumok betöltése nem sikerült.',
      DOWNLOAD_ERROR: 'Az ügydokumentumok letöltése nem sikerült.',
    },
  },
};
